.pes-cc-price {
  padding: 0;
  margin: 6px 0;
  font-weight: bold;
  color: #333333;
  font-size: 18px;
  line-height: 25px;
}

@media screen and (min-width: 980px) {
  .pes-cc-price {
    font-size: 16px;
  }

  :host(:not([dir="rtl"])) .pes-cc-price {
    text-align: left;
  }

  :host([dir="rtl"]) .pes-cc-price {
    text-align: right;
  }
}

.pes-cc-price__label {
  font-size: 14px;
  line-height: 1.4285714286;
  display: block;
  margin-bottom: 10px;
  font-weight: normal;
}